export default class SolrSearch {
    constructor($resource, urls) {
        'ngInject';
        return $resource(`${urls.solr}/:core`, {}, {
            get: {
                method: 'GET',
                timeout: 60000
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/search-interface/shared/models/SolrSearch.js